import styled from "styled-components";

import { ButtonWrapper } from "../../shared";

const MainOptionButtonWrapper = styled(ButtonWrapper)`
  padding: 16px 16px 16px 8px;
  margin: 0 -8px;
  max-width: fit-content;
  height: 56px;
  border-radius: 28px;
`;

export default MainOptionButtonWrapper;
